import React, { FC, useContext } from 'react';
import { AnnotationData } from './types';
import {
  QuizDialogAnnotationText,
  QuizDialogAnnotationTextArea,
  QuizDialogAnnotationRadio,
  QuizDialogAnnotationCheckbox,
  QuizDialogAnnotationSelect,
} from './quiz.styled';
import { PdfAnnotationFieldType } from './const';
import { QuizContext } from './quiz-context';

const QuizAnnotation: FC<AnnotationData & { pageIndex: number }> = props => {
  const { pregnancyValues, setPregnancyValues } = useContext(QuizContext);
  const {
    fieldType,
    fieldName,
    readOnly,
    multiLine,
    checkBox,
    combo,
    fieldValue,
    buttonValue,
    maxLen,
    options,
    rect,
    pageIndex,
  } = props;

  const fieldProps = {
    name: `${pageIndex}[${fieldName}]`,
    id: fieldName,
    maxLength: maxLen,
    $width: rect[2] - rect[0],
    $height: (rect[1] - rect[3]) * 0.9,
    $top: rect[1] + 3 - (rect[1] - rect[3]),
    $left: rect[0],
  };

  if (readOnly) {
    return null;
  }

  const onChange = e => {
    setPregnancyValues({
      ...pregnancyValues,
      [pageIndex]: {
        ...pregnancyValues[pageIndex],
        data: { ...pregnancyValues[pageIndex].data, ...(e.target && { [fieldName]: e.target.value || '' }) },
      },
    });
  };

  if (fieldType === PdfAnnotationFieldType.TEXT) {
    const textProps = {
      onChange,
      value: pregnancyValues[pageIndex] ? pregnancyValues[pageIndex].data[fieldName] || '' : '',
    };
    return multiLine ? (
      <QuizDialogAnnotationTextArea {...{ ...fieldProps, ...textProps }} />
    ) : (
      <QuizDialogAnnotationText type="text" {...{ ...fieldProps, ...textProps }} />
    );
  }

  if (fieldType === PdfAnnotationFieldType.BUTTON && !checkBox) {
    return (
      <QuizDialogAnnotationRadio
        type="radio"
        {...{
          ...fieldProps,
          value: buttonValue,
          checked: pregnancyValues[pageIndex] ? buttonValue === pregnancyValues[pageIndex].data[fieldName] : '',
          onChange,
        }}
      />
    );
  }

  if (checkBox) {
    return (
      <QuizDialogAnnotationCheckbox
        type="checkbox"
        {...{
          ...fieldProps,
          checked: pregnancyValues[pageIndex] && pregnancyValues[pageIndex].data[fieldName],
          onChange: e => {
            setPregnancyValues({
              ...pregnancyValues,
              [pageIndex]: {
                ...pregnancyValues[pageIndex],
                data: {
                  ...pregnancyValues[pageIndex].data,
                  ...(e.target && { [fieldName]: e.target.checked }),
                },
              },
            });
          },
        }}
      />
    );
  }

  if (combo) {
    return (
      <QuizDialogAnnotationSelect
        {...{
          ...fieldProps,
          onChange,
          value: pregnancyValues[pageIndex]
            ? pregnancyValues[pageIndex].data[fieldName]
            : fieldValue[0] || options[0].exportValue,
        }}
      >
        {options.map(({ exportValue, displayValue }) => (
          <option key={exportValue} value={exportValue}>
            {displayValue}
          </option>
        ))}
      </QuizDialogAnnotationSelect>
    );
  }

  return null;
};

export default QuizAnnotation;
